// Port of api/fuel/app/classes/filter/search/lists/filters/query/owner.php
export default {
	name: 'list.owner',
	priority: 1,
	require: function(config, filter) { return true },
	run: function(config, filter, data, query) {
		var ownerField = config.ownerType === 1 ? 'l.user_id' : (config.ownerType === 2 ? 'l.group_id' : 'l.buddies_id')
		query.where(ownerField, '=', config.owner.get_id())
	}
}
